<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  created(){
    this.$router.beforeEach((to, from, next) => {
      // console.log(from,"上级路由");
      var lastVisitedPageFlag=localStorage.getItem("lastVisitedPageFlag")
      if(lastVisitedPageFlag){
        localStorage.removeItem("lastVisitedPage")
      }else{
        localStorage.setItem('lastVisitedPage', from.fullPath);
      }
      localStorage.setItem('globalErrorMessage', true);
      //  console.log(to.fullPath,"当前路由");
      next()
    })
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  /* font: normal 12px/1 "Gotham A", "Gotham B",sans-serif; */
  font-family: normal 14px/1 "HelveticaNeueLTPro-Roman", sans-serif,
    PingFangSC-Regular, Microsoft YaHei, Hiragino Sans GB;
  font-size: 12px;
  color: #444;
}
a {
  color: #071c2c;
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
ul,
ol {
  list-style: none;
}
button {
  cursor: pointer;
}
h2,
h3,
h4,
h5 {
  font-weight: normal;
}
img {
  max-width: 100%;
}
.mt-40 {
  margin-top: 40px;
}
.mt-30 {
  margin-top: 30px;
}
.mt-20 {
  margin-top: 20px;
}
.mt-10 {
  margin-top: 10px;
}
.mb-40 {
  margin-bottom: 40px;
}
.mb-30 {
  margin-bottom: 30px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mb-10 {
  margin-bottom: 10px;
}
.routerLinkButton {
  width: 100%;
  line-height: 45px;
  border: 0;
  outline: none;
  background: #666;
  font-size: 12px;
  text-align: center;
  color: #fff;
  cursor: pointer;
  display: block;
}
.routerLinkButton:hover {
  background: #666;
  color: #fff;
}
#app {
  font: normal 14px/1 "HelveticaNeueLTPro-Roman", sans-serif, PingFangSC-Regular, Microsoft YaHei, Hiragino Sans GB, Microsoft YaHei, Hiragino Sans GB;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color:#464646
}

/* 更改element */
div .el-breadcrumb {
  font-size: 13px;
  padding-bottom: 10px;
  /* border-bottom: 1px solid #E1E1E1; */
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #636363 !important;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #636363 !important;
  border-color: #636363 !important;
}
.el-checkbox__label {
  font-size: 12px !important;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #636363 !important;
}
.el-radio__input.is-checked + .el-radio__label {
  color: #636363 !important;
}
.el-radio__inner::after {
  /* background-color: #636363 !important; */
}
.el-radio__input.is-checked .el-radio__inner {
  /* border-color: #636363 !important; */
  /* background: #fff !important; */
}
.el-input__inner {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/App.vue